import { z } from 'zod';

/**
 * Material (Modul engineering, ADR 0031): 3-stelliger Code — der letzte Block der
 * Artikelnummer (`XXXX.YYYYY.ZZZ`) mit Klartext-Name.
 */
export const materialCodeSchema = z.string().trim().regex(/^\d{3}$/, 'Materialcode muss genau 3 Ziffern sein.');

export const createMaterialSchema = z.object({
  code: materialCodeSchema,
  name: z.string().trim().min(1).max(160),
  isActive: z.boolean().optional(),
});
export type CreateMaterialInput = z.infer<typeof createMaterialSchema>;

export const updateMaterialSchema = createMaterialSchema.partial();
export type UpdateMaterialInput = z.infer<typeof updateMaterialSchema>;

export const materialResponseSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  code: z.string(),
  name: z.string(),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type MaterialResponse = z.infer<typeof materialResponseSchema>;
